/* マイページ開設完了 */
import React from 'react';
import ReactDOM from 'react-dom';
import { email_domain } from '../../Const';

const MypageOpeningPreliminaryComplete: React.FC = () => {
  return (
    <div className="container my-5">
      <p className="title text-center">マイページ開設完了</p>
      <p>
        マイページを開設しました。
        <br />
        ご登録のメールアドレスにURLを送信しました。
        <br />
        メールボックスをご確認下さい。
      </p>
      <p>
        メールが届かない場合は、メールアドレスをご確認の上、前のページに戻り再度送信して下さい。
      </p>
      <p>
        なお、併行からのメールは「{email_domain}」より配信されます。
        <br />
        ドメイン指定受信される際は「{email_domain}」からのメールを受信できるようにご設定下さい。
      </p>

      <div className="row">
        <div className="col-md-4">
          <div className="p-back-btn-box">
            <a className="c-btn btn-large btn-main-color" data-back>
              戻る
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

if (document.getElementById('mypage-opening-preliminary-complete')) {
  ReactDOM.render(
    <MypageOpeningPreliminaryComplete />,
    document.getElementById('mypage-opening-preliminary-complete')
  );
}
